import React, {useEffect, useState} from 'react';
import {Box} from "@mui/material";
import WarehouseFinishedDetailService
    from "../../../../API/orders/cutting/warehousefinisheddetail/WarehouseFinishedDetailService";
import DetailTable from "../../../../components/UI/table/cutting/details/DetailTable";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {useLocation} from "react-router-dom";
import {withFilter} from "../../../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../../../data/FilterTables/DetailFilterData";

const ComponentDetailWithFilter = withFilter(DetailTable, DetailFilterData);

const Cutting = () => {
    const pathname = useLocation().pathname
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [unableCut, setUnableCut] = useState({});
    const [unableTurn, setUnableTurn] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [status, setStatus] = useState(true);
    const [typeStatus, setTypeStatus] = useState(null);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    useEffect(() => {
        getStartPageSize()
        WarehouseFinishedDetailService.getAll().then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data?.length}))
            data.forEach((row) => {
                unableCut[row.id] = row.cut;
                unableTurn[row.id] = row.turn;
            });
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{
            '& > *': {
                marginTop: '20px',
            }
        }}>
            <ComponentDetailWithFilter
                data={data}
                setData={setData}
                unableCut={unableCut}
                unableTurn={unableTurn}
                setUnableCut={setUnableCut}
                setUnableTurn={setUnableTurn}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                modalStatusOpen={modalStatusOpen}
                setModalStatusOpen={setModalStatusOpen}
                status={status}
                setStatus={setStatus}
                typeStatus={typeStatus}
                setTypeStatus={setTypeStatus}
                isColumnMaterial={false}
                warehouse={'WarehouseFinishedDetail'}
                handleModalAlert={handleModalAlert}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default Cutting;